
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.167 16.666v-2.5h-2.5V12.5h2.5V10h1.667v2.5h2.5v1.666h-2.5v2.5h-1.667zm-5-2.5H5.834c-1.153 0-2.136-.406-2.948-1.218-.813-.813-1.219-1.796-1.219-2.948 0-1.153.406-2.136 1.219-2.948.812-.813 1.795-1.219 2.948-1.219h3.333V7.5H5.834a2.41 2.41 0 00-1.771.729 2.41 2.41 0 00-.73 1.77c0 .695.244 1.285.73 1.771.486.487 1.076.73 1.77.73h3.334v1.666zm-2.5-3.333V9.166h6.667v1.667H6.667zM18.334 10h-1.667c0-.695-.243-1.285-.73-1.771a2.41 2.41 0 00-1.77-.73h-3.333V5.834h3.333c1.153 0 2.135.406 2.948 1.219.812.812 1.219 1.795 1.219 2.948z"}})])
          )
        }
      }
    